import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import SiteSearchPc from './pc.jsx';
import SiteSearchMb from './mb.jsx';
import './styles.css';

/**
 *  SiteSearch
 */
class SiteSearch extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcSearchCode: PropTypes.string,
    mbSearchCode: PropTypes.string,
    scrollToSearchTop: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcSearchCode: null,
    mbSearchCode: null,
    scrollToSearchTop: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
      >
        <SiteSearchPc
          searchCode={this.props.pcSearchCode}
        />
        <SiteSearchMb
          searchCode={this.getMbSearchCode()}
          scrollToSearchTop={(this.props.scrollToSearchTop !== null) ? this.props.scrollToSearchTop: null}
        />
      </Wrapper>
    )
  }
  
  //
  getMbSearchCode = (e) => {
    if (this.props.mbSearchCode !== null) {
      return this.props.mbSearchCode;
    } else {
      return this.props.pcSearchCode;
    }
  };
  
}

export default SiteSearch;



// WEBPACK FOOTER //
// ./src/containers/site-search/index.jsx